import Proptypes from 'prop-types';
import React from 'react';

const Trade = ({ height = '32', width = '32' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      className="college-branded-icon-stroke"
      d="M24.6667 11.3333H14"
      stroke="#006894"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M18 20.6667H7.33337"
      stroke="#006894"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M20.6667 15.3333L24.6667 11.3333L20.6667 7.33331"
      stroke="#006894"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M11.3334 24.6667L7.33337 20.6667L11.3334 16.6667"
      stroke="#006894"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M16 31.3333C24.4684 31.3333 31.3334 24.4684 31.3334 16C31.3334 7.53162 24.4684 0.666656 16 0.666656C7.53166 0.666656 0.666687 7.53162 0.666687 16C0.666687 24.4684 7.53166 31.3333 16 31.3333Z"
      stroke="#006894"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Trade.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default Trade;
